
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';

// Internal
import { store, StoreActions, StoreMutations } from '@/store';
import { Azione, VariazioneLavorazione, LavorazioneSlim } from '@/models';
import { Loading } from '@/components';

@Component({
  name: 'AzioniLavorazioni',
  components: {
    Loading
  }
})
export default class AzioniLavorazioni extends Vue {
  private azione: string | null = null;
  private dialog: boolean = false;
  private menu1: boolean = false;
  private date: string = '';
  private dateFormatted: string = '';

  get isLoading(): boolean {
    return store.state.loading;
  }

  get lavorazioniSelezionate(): LavorazioneSlim[] {
    return store.state.listaLavorazioniSelezionate;
  }

  get azioniPossibili() {
    return store.state.azioniLavorazioni.map(l => l.azioni).flat();
  }

  get isNegoziazione(): boolean {
    return this.azione === Azione.RICHIEDI_VARIAZIONE;
  }

  get computedDateFormatted () {
      return this.formatDate(this.date);
  }

  @Watch('date')
  onDateChange(): void {
      this.dateFormatted = this.formatDate(this.date)
  }

  formatIsoDate(date: string): string {
      if (!date) return '';

      return dayjs(date).format('DD/MM/YYYY');
  }

  formatDate (date: string): string {
      if (!date) return '';

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
  }

  parseDate (date: string): string {
      if (!date) return '';

      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  private async eseguiAzione(azione: string) {
    this.azione = azione;

    this.dialog = true;
  }

  private async completaAzione() {
    if (this.isNegoziazione) {
      if (!this.date || this.date.length == 0) {
        store.commit(StoreMutations.SetMessaggiErrore, [
          'Data per richiesta variazione non specificata!'
        ]);
        return;
      }

      let variazione: VariazioneLavorazione = {
        variazioneDataConsegnaProposta: dayjs(this.date).toISOString()
      };

      await store.dispatch(StoreActions.RichiediVariazioniLavorazioni, {
        ids: store.state.listaLavorazioniSelezionate.map(l => l.id),
        variazione: variazione
      });
    } else {
      await store.dispatch(StoreActions.EseguiAzionePerLavorazioni, {
        ids: store.state.listaLavorazioniSelezionate.map(l => l.id),
        azione: this.azione
      });
    }

    this.dialog = false;

    store.commit(StoreMutations.SetAzioniVisibili, false);
  }
}
